import React, { Component } from 'react'
import Input from '../Login/Form/Input'
import { NavLink } from 'react-router-dom'
import Banner from '../Login/Banner'
import  {checkEmailForResettingPassword , updatePassword}  from '../services/authService'

export default class PwdReset extends Component {
 constructor(props){
     super(props)
}
state = {
    email:"",
    hasError:false,
    errorMessage:"",
    password:"",
    passwordConfirm:"",
    isEmailExists:false,
    isCheckingEmail:false,
    isUpdating:false,
    hasSuccess:false,
    successMessage:""
}
checkEmail = async(e) =>{
    e.preventDefault()
    this.setState({isCheckingEmail:true})
    let {email} = this.state
    if(email.length < 1){
        this.setState({
            hasError:true,
            errorMessage:"Please provide the email",
            isCheckingEmail:false
        })
    }
    else{
        try {
            this.setState({isCheckingEmail:true})
            let response = await checkEmailForResettingPassword(email)
            this.setState({
                isEmailExists:true,
                hasError:false,
                isCheckingEmail:false
            })
        } catch (error) {
            if(error.response.data.status == 400 ||error.response.data.status == 500 ){
                this.setState({
                    hasError:true,
                    errorMessage:error.response.data.message,
                    isCheckingEmail:false
                })
            }
        }
    }
}
handleEmailChange = (e) =>{
    this.setState({email:e.target.value})
}
handlePasswordChange = (e) =>{
    this.setState({password:e.target.value})
}
handlePasswordConfirmChange = (e) =>{
    this.setState({passwordConfirm:e.target.value})
}
hideMessage = () =>{
    this.setState({hasError:false})
}
updatePassword = async(e) =>{
    e.preventDefault()
    this.setState({isUpdating:true})
    let {email , password , passwordConfirm} = this.state
    if(password.length < 1 || passwordConfirm.length < 1){
        this.setState({
            hasError:true,
            errorMessage:"Please provide the password and confirm it",
            isUpdating:false
        })
    }else if(password !== passwordConfirm){
        this.setState({
            hasError:true,
            errorMessage:"Password confirmation doesn't match",
            isUpdating:false
        })
    }else{
        try {
            let response = await updatePassword(email , password)
            this.setState({
                isUpdating:false,
                hasSuccess:true,
                successMessage:response.message,
                password:"",
                passwordConfirm:"",
                email:""
            })            
        } catch (error) {
            if(error.response.status == 400 ||error.response.status == 500 ){
                this.setState({
                    hasError:true,
                    errorMessage:error.response.data.message,
                    isUpdating:false,
                    hasSuccess:false
                })
            }
        }
    }
}
  render() {
    return (
       <div className='grid lg:grid-cols-2'>
           <div className="cols-span-1">
                <Banner />
            </div>
            <div className='cols-span-1'>
          <div className='flex items-center justify-center w-full h-full'>
              <div className='p-8'>
              <div className='mb-8'>
                  <span className='text-2xl font-bold uppercase'>Password Reset Form</span>
              </div>
              <form onSubmit={!this.state.isEmailExists ? this.checkEmail : this.updatePassword}>
                        {
                            !this.state.isEmailExists &&
                            <Input
                                type="email"
                                label=" enter your email"
                                name="email"
                                id="email"
                                value={this.state.email}  
                                onChange={this.handleEmailChange}                     
                                />
                        }
                         {
                             this.state.isEmailExists && 
                             <div>
                                 <Input
                                type="password"
                                label=" enter new password"
                                name="password"
                                id="password"
                                value={this.state.password}  
                                onChange={this.handlePasswordChange}                     
                                />
                             <Input
                                type="password"
                                label="confirm new password"
                                name="password"
                                id="password"
                                value={this.state.passwordConfirm}  
                                onChange={this.handlePasswordConfirmChange}                     
                                />
                             </div>
                             
                         }
                        {
                            !this.state.hasSuccess && 
                            <div className="mt-4 mb-6">
                            {
                                !this.state.isEmailExists ?
                                <button type='submit'  className={!this.state.isCheckingEmail ?"w-full px-3 py-3 text-base font-bold text-white bg-yellow-600 rounded-md":"w-full px-3 py-3 text-base font-bold text-white bg-yellow-300 rounded-md"}>
                                    {!this.state.isCheckingEmail ? "Verify Email":"Verifying..."}
                                </button>:
                                <button type='submit'  className={!this.state.isUpdating ?"w-full px-3 py-3 text-base font-bold text-white bg-yellow-600 rounded-md":"w-full px-3 py-3 text-base font-bold text-white bg-yellow-300 rounded-md"}>
                                    {!this.state.isUpdating ? "Update Password":"Updating......"}
                                </button>
                            }
                        </div>
                        }
                            <div className='flex justify-between'>
                            <NavLink to="/" className="mt-4 text-sm">
                            <span className='text-blue-500'>Return Home</span>
                            </NavLink>
                            {
                                (this.state.isEmailExists && !this.state.hasSuccess) &&
                                <span 
                            onClick={()=>this.setState({
                                isEmailExists:false,isCheckingEmail:false
                            })}
                            className='mt-4 text-sm text-blue-500 cursor-pointer'>Re-enter email
                            </span>
                            }
                            </div>
                </form>
                    {
                        this.state.hasError && 
                       <div className="flex justify-between p-4 bg-red-700 rounded-md">
                         <span className="text-sm text-center text-white">{this.state.errorMessage}</span>
                         <svg onClick={this.hideMessage} className="w-5 h-5 text-white cursor-pointer" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
                       </div>
                    }
                    {
                        this.state.hasSuccess && 
                       <div className="flex justify-between p-4 bg-green-500 rounded-md">
                         <span className="text-sm text-center text-white">{this.state.successMessage}</span>
            
                       </div>
                    }
              </div>
          </div>
      </div>
            </div>
    )
  }
}
